/*
 * @Author: Branton
 * @Date: 2025-10-28 17:01:49
 * @LastEditTime: 2025-11-26 14:25:57
 * @LastEditors: Branton
 * @Description:
 * @FilePath: \Rms-Tender-Frontend\src\views\pages\AnnouncementDetails\hooks\AnnouncementDetail\Project\data.tsx
 * 暂无
 */
import { numFormat, valToString } from '@utils/tool';
import { COMMON_BOOLEAN_LABEL_MAP } from '../../../../../../components/ProjectFromComponents/data';

export const Project_COLUMNS: any = [
  {
    title: '标的物',
    dataIndex: 'subjectMatterName',
    key: 'subjectMatterName'
  },
  {
    title: '标的物品牌',
    dataIndex: 'subjectMatterBrand',
    key: 'subjectMatterBrand'
  },
  {
    title: '标的物型号',
    dataIndex: 'subjectMatterModel',
    key: 'subjectMatterModel'
  },
  {
    title: '标的物中标单价(万元)',
    dataIndex: 'subjectMatterPrice',
    key: 'subjectMatterPrice',
    render: (val: any, record: any) => {
      const text = numFormat(val);
      return (
        !text || text + ' ' + valToString(record.subjectMatterCurrencyValue)
      );
    }
  },
  {
    title: '数量',
    dataIndex: 'subjectMatterNumber',
    key: 'subjectMatterNumber'
  },
  {
    title: '标的物中标总价(万元)',
    dataIndex: 'totalAmount',
    key: 'totalAmount',
    render: (val: any, record: any) => {
      const text = numFormat(val);
      return !text || text + ' ' + valToString(record.totalAmountCurrencyValue);
    }
  },
  {
    title: '是否已知项目',
    dataIndex: 'coverageStatus',
    key: 'coverageStatus',
    render: (val: any) => {
      return COMMON_BOOLEAN_LABEL_MAP[val] ?? '';
    }
  },
  {
    title: 'Opportunity ID',
    dataIndex: 'oppId',
    key: 'oppId'
  },
  {
    title: '是否新建Pros',
    dataIndex: 'prosNumStatus',
    key: 'prosNumStatus',
    render: (val: any) => {
      return COMMON_BOOLEAN_LABEL_MAP[val] ?? '';
    }
  },
  {
    title: '状态',
    width: 100,
    dataIndex: 'subjectMatterProjectStatusValue',
    key: 'subjectMatterProjectStatusValue',
    fixed: 'right'
  },
  {
    title: '负责销售',
    width: 100,
    dataIndex: 'subjectMatterProjectSaleName',
    key: 'subjectMatterProjectSaleName',
    fixed: 'right'
  }
];
